// src/core/imcmd/types.ts
/** Ключ пространства имен по умолчанию */
const DEFAULT_NS = "default";
/** Индентификатор по умолчанию */
const DEFAULT_ID = "default";
/**
 * Универсальный цикл исполнения команд по targetItems.
 *
 * @param token Токен команды
 * @param ctx Контекст вызова
 * @param resolver Коллбэк для обработки элемента:
 *                 - вернуть false → элемент не обработан (уйдёт в unhandled)
 *                 - вернуть true | UiCommandResult | UiCommandResult[] → обработан
 * @returns
 *   - false, если ничего не обработано;
 *   - true, если обработано без спец-результатов;
 *   - UiCommandResult, если резолвер вернул спец-результаты.
 */
function executeOnItems(token, ctx, resolver) {
    if (!token.targetItems || token.targetItems.length === 0)
        return false;
    const unhandled = [];
    const results = [];
    for (const el of token.targetItems) {
        try {
            const r = resolver(el, token, ctx);
            if (r === false) {
                unhandled.push(el);
            }
            else if (r !== true) {
                // 2026-03-26:
                // resolver может вернуть UiCommandResult[] (например, цепочка imcmd).
                // Сохраняем все результаты, чтобы не потерять сигналы usecmd/preventDefault.
                if (Array.isArray(r)) {
                    results.push(...r);
                }
                else {
                    results.push(r);
                }
            }
        }
        catch (e) {
            console.error(`[imcmd]`, token.command, el, e);
            unhandled.push(el);
        }
    }
    // Обновляем targetItems для следующих провайдеров
    token.targetItems = unhandled.length > 0 ? unhandled : [];
    if (results.length > 0)
        // 2026-03-26:
        // Возвращаем ОДИН объект результата (а не массив),
        // чтобы не ломать сигнатуры провайдеров execute(): UiCommandResult | boolean
        // (фикс ошибки TS2322 в TableUiCommandProvider и аналогичных местах).
        return Object.assign({}, ...results);
    return unhandled.length === 0;
}

export { DEFAULT_ID, DEFAULT_NS, executeOnItems };
